module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("M34zv"))).then(() => parcelRequire('2KbAe'));